<div class="d-flex flex-column gap-3 p-3 align-items-center">
  <div class="text-end w-100">
    <img src="assets/svg/icon-close.svg" alt="icon-close.svg" class="pointer">
  </div>
  <p class="fw-bold text-blue">Tu mensaje fue enviado con éxito</p>
  <div class="content-text text-center">
    <p class="fs-light fs-7 text-blue">Un Asesor(a) Kaizen se pondrá en contacto contigo durante el día.</p>
  </div>
  <div class="btn-continue d-flex align-items-center justify-content-center pointer gap-3 rounded mb-4" (click)="closeDialog()">
    <span class="text-white fs-7">{{ buttonText }}</span>
  </div>
</div>